module.exports = __webpack_public_path__ + "img/v1-dashboard.9d75ad35.png";